import React from "react";

import getOrderStatus from "../../../../lib/getOrderStatus";
import getEstimatedTime from "../../../../lib/getRecentEstimationTime";

const getStatusText = (orderStatus, deliveryType) => {
  return getOrderStatus(orderStatus, deliveryType);
};

const PostLoginOrders = ({
  recentOrders,
  pastOrders,
  handleOrderDetail,
  getOrderDate,
  handleRateOrder,
  handleReOrder
}) => {
  return (
    <div className="col-sm-6">
      {(recentOrders.length &&
        recentOrders.map(order => {
          const estimatedTime = getEstimatedTime(
            order.orderEarliestDeliveryDeadline,
            order.orderLatestDeliveryDeadline
          );
          return (
            <div
              className="recent-order mt-10px cursor-pointer"
              key={order.uid}
              onClick={() => handleOrderDetail(order.uid)}
            >
              <div className="row status hide-xs">
                <div className="col-sm-4 left">
                  <div className="white-bg">
                    <div>
                      <p> #{order.uid}</p>
                      <h4>{getStatusText(order.status, order.deliveryType)}</h4>
                    </div>
                  </div>
                </div>
                {/* .left */}

                <div className="col-sm-8 right">
                  <div className="white-bg">
                    <div>
                      <p>{order.restaurant.name}</p>
                      <div className="d-flex align-items-center mt-10px mb-10px">
                        <p className="mr-1">
                          £{parseFloat(order.total).toFixed(2)}
                        </p>
                        <p className="bold">+{order.earnedPoints} eCoins</p>
                      </div>
                      {estimatedTime && (
                        <p>Estimated delivery time {estimatedTime}</p>
                      )}
                    </div>
                  </div>
                </div>
                {/* .right */}
              </div>
              {/* .status */}

              <div className="d-flex justify-content-between visible-xs">
                <div className="left">
                  <h5>{getStatusText(order.status, order.deliveryType)}</h5>
                  <div>
                    <p>{order.restaurant.name}</p>
                    <div className="price">
                      <p>£{parseFloat(order.total).toFixed(2)}</p>
                      <p className="bold">+{order.earnedPoints} eCoins</p>
                    </div>
                  </div>
                  <p>
                    Estimated delivery time{" "}
                    {getEstimatedTime(
                      order.orderDate,
                      order.preparationTime,
                      order.orderEarliestDeliveryDeadline,
                      order.orderLatestDeliveryDeadline
                    )}
                  </p>
                </div>

                <a href="javascript: void(0)" className="bold">
                  #{order.uid}
                </a>
              </div>
            </div>
          );
        })) || <noscript />}

      {(pastOrders.length && (
        <div className="list-item">
          <h5>Past</h5>
          {pastOrders.map(order => (
            <div key={order.uid} className="item">
              <div
                className="d-flex align-items-center cursor-pointer"
                onClick={() => handleOrderDetail(order.uid)}
              >
                <p className="p-clock">{getOrderDate(order.orderDate)}</p>
                <div>
                  <h4>Order #{order.uid}</h4>
                  <p className="p-name">{order.restaurant.name}</p>
                  <p className="p-price">
                    £{parseFloat(order.subTotal).toFixed(2)}{" "}
                    <span>+{order.earnedPoints} eCoins</span>
                  </p>
                </div>
              </div>
              <div className="buttons d-flex align-items-center">
                {(order.userCanRate && (
                  <a
                    onClick={() => handleRateOrder(order.uid)}
                    href="javascript: void(0)"
                    className="btn btn-blue"
                  >
                    Rate
                  </a>
                )) || <noscript />}
                {(order.userCanReOrder && (
                  <a
                    onClick={() => handleReOrder(order.uid)}
                    href="javascript: void(0)"
                    className="btn btn-gray"
                  >
                    Reorder
                  </a>
                )) || <noscript />}
              </div>
            </div>
          ))}

          <a href="/profile?orders" className="btn btn-blue see-more hide-xs">
            All previous orders
          </a>
        </div>
      )) || <noscript />}

      <a href="/profile?orders" className="see-more visible-xs">
        See More...
      </a>
    </div>
  );
};

export default PostLoginOrders;
